import { isValid } from "date-fns";

export const isDateOfBirthValid = (dateOfBirth?: Date | null) => {
  if (!dateOfBirth) return false;

  const endOfDayToday = new Date().setHours(23, 59, 59, 998);

  return (
    isValid(dateOfBirth) &&
    dateOfBirth?.getFullYear() > 1900 &&
    dateOfBirth?.getTime() <= endOfDayToday
  );
};
